import React, { Component } from "react";
import SignatureCanvas from "react-signature-canvas";
import styled from "styled-components";

const SignatureCanvasContainer = styled.div`
  border: 1px dashed #eee;
  border-bottom: 2px solid #999;
  display: inline-block;
  cursor: pointer;
`;

class SignatureCanvasResponsiveEditable extends Component {
  constructor(props) {
    super(props);
    this.signatureCanvasRef = React.createRef();
    this.signatureCanvasContainerRef = React.createRef();
    this.state = {};
  }

  _signatureData() {
    return this.signatureCanvasRef.current.toData();
  }

  _clear() {
    return (
      this.signatureCanvasRef.current && this.signatureCanvasRef.current.clear()
    );
  }

  _hasSignature() {
    return (
      this.signatureCanvasRef.current &&
      _.size(this.signatureCanvasRef.current.toData()) > 0
    );
  }

  _width() {
    return this.state.canvasWidth;
  }

  _height() {
    const { widthHeightRatio } = this.props;
    return this.state.canvasWidth / widthHeightRatio;
  }

  render() {
    const { widthHeightRatio, penColor } = this.props;

    return (
      <div
        ref={(ref) =>
          ref &&
          !this.state.canvasWidth &&
          this.setState({ canvasWidth: ref.offsetWidth })
        }
      >
        <SignatureCanvasContainer>
          {this.state.canvasWidth && (
            <SignatureCanvas
              ref={this.signatureCanvasRef}
              penColor={penColor}
              canvasProps={{
                width: this.state.canvasWidth,
                height: this.state.canvasWidth / widthHeightRatio,
                className: "sigCanvas",
              }}
            />
          )}
        </SignatureCanvasContainer>
      </div>
    );
  }
}

export default SignatureCanvasResponsiveEditable;
